// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Cx4J","footer":"ReportModalFilter_footer__Oo1hu"};